<template>
  <a-card :bordered="false">
    <!-- 查询 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item label="岗位名称">
              <a-input
                placeholder="请输入岗位名称"
                v-model="queryParam.postName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item label="地址">
              <a-input
                placeholder="请输入地址"
                v-model="queryParam.site"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-button type="primary" @click="searchQuery" icon="search"
              >查询</a-button
            >
            <a-button
              type="default"
              @click="searchReset"
              icon="reload"
              style="margin-left: 8px"
              >重置</a-button
            >
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button
        @click="handleAdd"
        type="primary"
        ghost
        icon="plus"
        style="margin-top: 5px"
        >新增</a-button
      >
      <a-button
        @click="batchDel"
        type="primary"
        ghost
        icon="plus"
        style="margin-top: 5px"
        >批量删除</a-button
      >
    </div>
    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :scroll="{ x: true }"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <!-- <span slot="id" slot-scope="text, record">{{ record.id }}</span> -->
        <span slot="postName" slot-scope="text, record">{{
          record.postName
        }}</span>
        <span slot="number" slot-scope="text, record">{{ record.number }}</span>
        <span slot="address" slot-scope="text, record">{{
          record.address
        }}</span>
        <span slot="positionDes" slot-scope="text, record">{{
          record.positionDes
        }}</span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record.id)">删除</a>
        </span>
      </a-table>
    </div>
    <userListModel ref="modalForm" @ok="modalFormOk"></userListModel>
  </a-card>
</template>

<script>
import userListModel from './userListModel';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { postAction } from '@/api/manage';
export default {
  name: 'userList',
  mixins: [JeecgListMixin],
  data() {
    return {
      loading: false,
      //   dataSource: [],
      value: '',
      columns: [
        // {
        //   title: 'id',
        //   align: 'center',
        //   dataIndex: 'id',
        // },
        {
          title: '岗位名称',
          align: 'center',
          dataIndex: 'postName'
        },
        {
          title: '招聘人数',
          align: 'center',
          dataIndex: 'number'
        },
        {
          title: '地址',
          align: 'center',
          dataIndex: 'address'
        },
        {
          title: '职位描述',
          align: 'center',
          dataIndex: 'positionDes'
        },
        {
          title: '任职资格',
          align: 'center',
          dataIndex: 'qualifications'
        },
        {
          title: '投递邮箱',
          align: 'center',
          dataIndex: 'email'
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
          sorter: true
        },

        {
          title: '创建人',
          align: 'center',
          dataIndex: 'createBy'
        },
        {
          title: '更新日期',
          align: 'center',
          dataIndex: 'updateTime',
          sorter: true
        },
        {
          title: '更新人',
          align: 'center',
          dataIndex: 'updateBy'
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          customRender: text => {
            if (text == 0) {
              return '创建';
            }
            if (text == 1) {
              return '删除';
            } else if (text == 2) {
              return '上架';
            } else if (text == 3) {
              return '下架';
            }
          }
        },

        {
          title: '招聘结束时间',
          align: 'center',
          dataIndex: 'endTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/content/position/list', //查询
        // listUserId: process.env.VUE_APP_CMS_CONTENT + '/content/position/info/{id}', //查询
        delete: process.env.VUE_APP_CMS_CONTENT + '/content/position/del',
        deleteBatch:
          process.env.VUE_APP_CMS_CONTENT + '/content/position/deleteBatch'
        // deleteBatch: '/sys/routingSetting/deleteBatch',
      }
    };
  },
  components: {
    userListModel
  },
  created() {
    this.loadData();
    this.getQueryParams();
  },
  methods: {
    handleDelete: function(id) {
      var that = this;
      this.$confirm({
        title: '删除',
        content: '确定删除吗?',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          if (that.dataSource.length == 1) {
            if (that.ipagination.current > 1) {
              that.ipagination.current = that.ipagination.current - 1;
            }
          }
          postAction(that.url.delete, { id: id }).then(res => {
            if (res.success) {
              let pageCount = parseInt(
                that.ipagination.total / that.ipagination.pageSize
              );
              let rest = that.ipagination.total % that.ipagination.pageSize;
              if (rest == 1 && that.ipagination.current > 1) {
                pageCount++;
                if (that.ipagination.current == pageCount) {
                  //如果是删除的最后一页最后一行
                  that.ipagination.current--;
                }
              }
              that.$message.success(res.message);
              that.loadData();
            } else {
              that.$message.warning(res.message);
            }
          });
        }
      });
    }
    // searchQuery(record) {
    //   console.log(record)
    //   if (id) {
    //     getAction(this.url.listUserId, { id: id }).then((res) => {
    //       if (res.success) {
    //         this.$message.success(res.message)
    //         this.loadData()
    //       }
    //     })
    //   }
    // },
  }
};
</script>

<style></style>
